/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_EndInputs */



/**
* | output |
* | --- |
* | "End practice conversation" |
*
* @param {Practice_Session_EndInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_end = /** @type {((inputs?: Practice_Session_EndInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_EndInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Beëindig oefengesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer l'entretien")
	return /** @type {LocalizedString} */ ("End practice conversation")
});